import React from 'react';
import Select, { components as piezasSelect } from 'react-select'; // Importa Select
import CreatableSelect from 'react-select/creatable'; // Importa CreatableSelect

/* FACTURA-UI: icono de busqueda a la izquierda del control. Es OPCIONAL y va
   detras de un prop, asi que ningun consumidor actual cambia de aspecto: un
   selector de dos opciones no necesita anunciar que se puede buscar, uno de
   miles si. */
const IconoBuscarSelect = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
       style={{ flex: "0 0 auto", marginLeft: 10, color: "var(--text-label)" }}>
    <circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" />
  </svg>
);

const ControlConIcono = ({ children, ...resto }) => (
  <piezasSelect.Control {...resto}>
    <IconoBuscarSelect />
    {children}
  </piezasSelect.Control>
);

export default function SelectSearchable({ listCompany, handleChange, selectedOption, placeholder,
  isMulti, create, styles, onInputChange, isDisabled, isClearable, serverSideSearch, conIconoBuscar }) {

  // RESULTADOS-19: cuando el filtrado real lo hace el servidor (onInputChange
  // dispara una busqueda remota y `listCompany` YA son los resultados de esa
  // busqueda), el filtro por substring del label local ESCONDE coincidencias
  // validas -- p.ej. el label es "CED - APELLIDOS NOMBRES" y el usuario escribe
  // el nombre en otro orden. `serverSideSearch` desactiva ese filtro local y
  // muestra tal cual lo que devolvio el servidor.
  const filterOption = serverSideSearch
    ? () => true
    : (option, inputValue) => {
        const searchable = option.data.searchLabel || option.label || "";
        return searchable.toLowerCase().includes((inputValue || "").toLowerCase());
      };

  const options = listCompany
    .map(company => ({
      ...company,
      value: company.value,
      label: company.label,
    }))
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  return create ? (
    <CreatableSelect
      className="basic-single"
      classNamePrefix="select"
      isSearchable={true}
      value={selectedOption}
      onChange={handleChange}
      options={options}
    />
  ) : (
    <div style={styles}>
      <Select
        value={selectedOption}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        isSearchable={true}
        filterOption={filterOption}
        {...(conIconoBuscar ? { components: { Control: ControlConIcono } } : {})}
        formatOptionLabel={(option) => (
          option.scope_label ? (
            <div>
              <div>{option.nombre || option.label}</div>
              <small className="text-muted">{option.scope_label}</small>
            </div>
          ) : option.label
        )}
        // Captura lo que se va escribiendo.
        //
        // El retorno se DESCARTA a proposito: react-select usa el valor que
        // devuelve `onInputChange` como nuevo texto del campo, y casi todos los
        // que lo usan aqui pasan una funcion `async` (una busqueda remota). Al
        // devolver la promesa, el campo mostraba literalmente
        // "[object Promise]" y dejaba de poder escribirse. El envoltorio hace
        // que ningun consumidor pueda volver a tropezar con esto.
        onInputChange={(valor, meta) => { onInputChange?.(valor, meta); }}
        // cantidad de select que se pueden seleccionar
        isMulti={isMulti ? true : false}
        // disabled={disabled}
        isDisabled={isDisabled ?? false}
        isClearable={isClearable ?? false}
      />
    </div>
  );
}
